import React from "react";
import classes from "./spinner.module.css";

const Spinner = ({ style }) => {
  return <div className={classes.spinner} style={style}></div>;
};

export default Spinner;
